document.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const marquees = document.querySelectorAll('[data-marquee-container]');

  marquees.forEach((container) => {
    const track = container.querySelector('[data-marquee-track]');
    if (!track) return;

    let direction = -1;
    let position = 0;
    const speed = 60;

    track.innerHTML += track.innerHTML;

    const trackWidth = track.scrollWidth / 2;

    track.style.willChange = 'transform';

    let lastTime = 0;
    let rafId;

    function frame(time) {
      if (!lastTime) lastTime = time;
      const delta = (time - lastTime) * 0.001;
      lastTime = time;

      position += direction * speed * delta;

      if (position <= -trackWidth) position += trackWidth;
      if (position >= 0) position -= trackWidth;

      track.style.transform = `translate3d(${position}px,0,0)`;

      rafId = requestAnimationFrame(frame);
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        lastTime = 0;
        rafId = requestAnimationFrame(frame);
      } else {
        cancelAnimationFrame(rafId);
      }
    });

    observer.observe(container);

    let startX = 0;
    let isDragging = false;

    container.addEventListener('pointerdown', (e) => {
      startX = e.clientX;
      isDragging = true;
    });

    container.addEventListener('pointerup', (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - startX;
      direction = deltaX < 0 ? -1 : 1;
      isDragging = false;
    });

    container.addEventListener('pointerleave', () => {
      isDragging = false;
    });
  });
});
